/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateMobileNotificationRequestViewModel } from "../types/CreateMobileNotificationRequestViewModel.ts";
import { eMobileNotificationStatusSchema } from "./eMobileNotificationStatusSchema.ts";

export const createMobileNotificationRequestViewModelSchema = z.object({
  title: z
    .string()
    .describe("Título da notificação. Obrigatório. Máximo 120 caracteres.")
    .nullish(),
  message: z
    .string()
    .describe(
      "Corpo/Mensagem da notificação. Obrigatório. Máximo 2000 caracteres.",
    )
    .nullish(),
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "Lista de IDs de turmas que receberão a notificação. Ignorado quando IsAllClassStudent = true.",
    )
    .nullish(),
  allowedEnrollmentStatus: z
    .array(z.number().int())
    .describe(
      "Filtro de status de matrícula. Apenas alunos com os status informados receberão a notificação. (Opcional) caso seja nulo será enviado para todas os status Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  isAllClassStudent: z.optional(
    z
      .boolean()
      .describe(
        "Quando true, envia para todas as turmas ativas, ignorando ClassStudentIds.",
      ),
  ),
  urlExternal: z
    .string()
    .describe(
      "URL externa para redirecionamento ao clicar na notificação. (Opcional)",
    )
    .nullish(),
  scheduledAtUtc: z
    .string()
    .datetime()
    .describe(
      "Data e hora de envio agendado (UTC). Obrigatório quando NotificationType = Scheduled.",
    )
    .nullish(),
  notificationType: z.optional(
    z
      .lazy(() => eMobileNotificationStatusSchema)
      .describe(
        "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
      ),
  ),
}) as unknown as ToZod<CreateMobileNotificationRequestViewModel>;
